//在此处编写调用授权等基本平台接口
import store from "@/store"
import axios from "axios";
let axiosUpload = axios.create({
	baseURL: "/api/v1/plat",
	timeout: 30000
});
axiosUpload.defaults.headers.put["Content-Type"] = "application/x-www-form-urlencoded";
axiosUpload.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

class plat_api {
	constructor(axiosFactory) {
		this.$http = axiosFactory;
		//获取基本类型
		this.getDegreesData = null;
		this.getLanguageData = null;
		this.getCompanyTypesData = null;
		this.getCompanyScalesData = null;
	}
	http() {
		return this.$http;
	}
	//图片上传
	uploadimg(data, cb) {
		axiosUpload.post('/fileManager/public/upload?productName=OPEN', data).then((res) => cb(res.data));
	}

	get(url, cb) {
		var URL = new EF.URL(url);
		if (URL.get("parentGuid")) URL.set("parentGuid", URL.get("parentGuid"));
		this.$http
			.get(URL.url())
			.then(res => {
				if (res.status === 200) {
					cb(res.data);
				}
			})
			.catch(err => {
				cb(err);
			});
	}

	gets(url, data, cb) {
		this.$http.get(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}

	//先判定本地是否存储，如果没有能够获取到本地存储，再次从远程获取；
	//name存储字段，url请求地址，cb回调函数
	getStorageData(name, url, cb) {
		var myObj = JSON.parse(localStorage.getItem(name));
		if (myObj) {
			cb(myObj);
		} else {
			this.$http.get(url).then(data => {
				cb(data.data);
				localStorage.setItem(name, JSON.stringify(data.data));
			});
		}
	}

	//获取所有基础数据
	getbasicAll(cb) {
		var data = JSON.parse(localStorage.getItem("configData"));
		if (data) {
			this.getDegreesData = data.data.degrees;
			this.getLanguageData = data.data.languages;
			this.getCompanyTypesData = data.data.companyTypes;
			this.getCompanyScalesData = data.data.companyScales;
			this.getregions = data.data.regions;
			cb(data);
		} else {
			this.get("/basicData/all", (data) => {
				if (data.status == '200') {
					this.getDegreesData = data.data.degrees;
					this.getLanguageData = data.data.languages;
					this.getCompanyTypesData = data.data.companyTypes;
					this.getCompanyScalesData = data.data.companyScales;
					this.getregions = data.data.regions;
					localStorage.setItem("configData", JSON.stringify(data));
					cb(data)
				}
			});
		};
	}
	//获取第一层行业
	getIndustries(cb) {
		this.get("/basicData/industries?topLevel=true", cb);
	}
	getNextIndustries(parentGuid, cb) {
		this.get("/basicData/industries?parentGuid=" + parentGuid, cb);
	}
	//获取职能
	getFunctions(parentGuid, cb) {
		this.get("/basicData/functions?parentGuid=" + parentGuid, cb);
	}
	//获取地点
	getAllCityPlace(cb) {
		this.get("/basicData/china/regions?topLevel=true", cb);
	}
	getCityPlace(parentGuid, cb) {
		this.get("/basicData/china/regions?parentGuid=" + parentGuid, cb);
	}
	//获取热门地点
	getAllCityIsHotPlace(cb) {
		this.get("/basicData/china/regions?isHot=true", cb);
	}
	//获取国家
	getCountrys(cb) {
		this.get("/basicData/countries?topLevel=true", cb);
	}
	getNextCountrys(parentGuid, cb) {
		this.get("/basicData/countries?parentGuid=" + parentGuid, cb);
	}
	//获取学历
	getDegrees(cb) {
		console.log(store.state.configData)
		const data = {
			data: {
				list: store.state.configData.degrees,
			},
			status: '200',
		}
		cb(data)

	}
	//获取语言
	getLanguage(cb) {
		var data = {
			data: store.state.configData.languages,
			status: '200',
		}
		cb(data)
	}
	//获取公司性质
	getCompanyTypes(cb) {

		var data = {
			data: {
				list: store.state.configData.companyTypes,
			},
			status: '200',
		}
		cb(data)
	}
	//企业规模
	getCompanyScales(cb) {

		var data = {
			data: {
				list: store.state.configData.companyScales,
			},
			status: '200',
		}
		cb(data)
	}
}
class apiFactory {
	constructor() {

	}
	createApi(axios) {
		return new plat_api(axios)
	}
}
export default new apiFactory();
